import React, { useState } from 'react';
import { LibraryBig, FileText } from 'lucide-react';
import TabPageLayout from 'modules/swiftboard/components/TabPageLayout';
import KnowledgeBase from './knowledge-base/KnowledgeBase';
import KnowledgeArticle from './knowledge-article/KnowledgeArticle.jsx';
import useUrlTab from "modules/swiftboard/components/useUrlTab";

const KnowledgeConfiguration = () => {
 
  const [activeTab, setActiveTab] = useUrlTab(["knowledge-base", "knowledge-article"]);
  const [tabCounts, setTabCounts] = useState({});

  const setTabCount = (tabId) => (count) =>
    setTabCounts((prev) => (prev[tabId] === count ? prev : { ...prev, [tabId]: count }));
 
  const subModulesTabs = [
    {
      id: 1,
      label: 'Knowledge Base',
      icon: <LibraryBig size={18} />,
    },
    {
      id: 2,
      label: 'Knowledge Article',
      icon: <FileText size={18} />,
    },
  ].map((tab, index) => ({
    ...tab,
    badge:
      index === activeTab && tabCounts[tab.id] !== undefined
        ? { count: tabCounts[tab.id], compact: true }
        : undefined,
  }));

  const handleTabChange = (index, tab) => {
    setActiveTab(index);
  }; 
  return (
    <TabPageLayout
      tabs={subModulesTabs}
      activeTab={activeTab}
      onTabChange={handleTabChange}
    >
      {activeTab === 0 && <KnowledgeBase onTotalCountChange={setTabCount(1)} />}
      {activeTab === 1 && <KnowledgeArticle onTotalCountChange={setTabCount(2)} />}
    </TabPageLayout>
  );
};

export default KnowledgeConfiguration;